(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const target = document.getElementById('oeko-tex-certificate');
    if (!target || window.location.hash !== '#oeko-tex-certificate') return;
    let allowAlignment = true;
    let frame;
    const align = () => {
      if (!allowAlignment || window.location.hash !== '#oeko-tex-certificate') return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }));
    };
    const stop = () => { allowAlignment = false; cancelAnimationFrame(frame); };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => window.addEventListener(name, stop, { once: true, passive: true }));
    if (document.readyState === 'complete') align();
    else window.addEventListener('load', align, { once: true });
    if (document.fonts) document.fonts.ready.then(align);
    target.closest('.main-page__content')?.querySelectorAll('img').forEach(image => {
      if (!image.complete) {
        image.addEventListener('load', align, { once: true });
        image.addEventListener('error', align, { once: true });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seisso-bath-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mounted = new Map();
    function mount(root) {
      if (mounted.has(root)) return;
      let data;
      try { data = JSON.parse(root.querySelector('[data-bath-variants]').textContent); } catch { return; }
      const count = root.querySelector('[data-bath-count]');
      const colors = root.querySelector('[data-bath-colors]');
      const packTitle = root.querySelector('[data-bath-pack-title]');
      const bannerPack = root.querySelector('[data-bath-banner-pack]');
      const hero = root.querySelector('[data-bath-hero]');
      const cardTitle = root.querySelector('[data-bath-card-title]');
      const slideTitle = root.querySelector('[data-bath-slide-title]');
      const slideText = root.querySelector('[data-bath-slide-text]');
      const slideTab = root.querySelector('[data-bath-slide-tab]');
      const carousel = root.querySelector('[data-bath-brand-track]');
      const arrows = [...root.querySelectorAll('[data-bath-brand-direction]')];
      const controller = new AbortController();
      const signal = controller.signal;
      let frame = 0;
      const video = root.querySelector('[data-bath-video]');
      const videoPlay = root.querySelector('[data-bath-video-play]');
      videoPlay?.addEventListener('click', () => {
        if (!video) return;
        videoPlay.hidden = true;
        video.hidden = false;
        const playback = video.play();
        if (playback?.catch) playback.catch(() => {});
      }, { signal });
      const detailTabs = [...root.querySelectorAll('[data-bath-detail-tab]')];
      const detailPanels = [...root.querySelectorAll('[data-bath-detail-panel]')];
      let activeDetail = 0;
      function update(id) {
        const variant = data.variants.find(item => String(item.id) === String(id));
        if (!variant) {
          count.textContent = data.unavailable;
          colors.textContent = '';
          if (bannerPack) bannerPack.hidden = true;
          if (packTitle) packTitle.hidden = true;
          if (cardTitle) cardTitle.hidden = true;
          if (slideTitle) slideTitle.hidden = true;
          if (slideText) slideText.hidden = true;
          return;
        }
        const format = template => template.replaceAll('[count]', variant.towelCount);
        count.textContent = format(data.countTemplate);
        colors.textContent = variant.colors;
        for (const [element, template] of [[bannerPack, data.bannerTemplate], [packTitle, data.packTitleTemplate], [cardTitle, data.cardTitleTemplate], [slideTitle, data.slideTitleTemplate], [slideText, data.slideTextTemplate], [slideTab, data.slideTabTemplate]]) {
          if (element) { element.hidden = false; element.textContent = format(template); }
        }
        if (hero) {
          const useOriginal = variant.towelCount === 2 && hero.dataset.heroOriginal;
          const targetSrc = useOriginal ? hero.dataset.heroOriginal : hero.dataset.heroNeutral;
          if (hero.getAttribute('src') !== targetSrc) hero.setAttribute('src', targetSrc);
          if (bannerPack) bannerPack.hidden = Boolean(useOriginal);
        }
      }
      function showDetail(index, focus = false) {
        if (!detailPanels.length) return;
        activeDetail = (index + detailPanels.length) % detailPanels.length;
        detailPanels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== activeDetail; });
        detailTabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === activeDetail;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        if (focus) detailTabs[activeDetail]?.focus();
      }
      detailTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => showDetail(index), { signal });
        tab.addEventListener('keydown', event => {
          let target = activeDetail;
          if (event.key === 'ArrowRight') target += 1;
          else if (event.key === 'ArrowLeft') target -= 1;
          else if (event.key === 'Home') target = 0;
          else if (event.key === 'End') target = detailPanels.length - 1;
          else return;
          event.preventDefault();
          showDetail(target, true);
        }, { signal });
      });
      root.querySelectorAll('[data-bath-detail-direction]').forEach(arrow => arrow.addEventListener('click', () => showDetail(activeDetail + Number(arrow.dataset.bathDetailDirection)), { signal }));
      function sync() {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          frame = 0;
          const productRoot = [...document.querySelectorAll('[data-product-root]')].find(element => element.dataset.productId === root.dataset.productId);
          const master = productRoot?.querySelector('[data-variant-id]');
          const id = master ? (master.disabled ? '' : master.value) : new URL(location.href).searchParams.get('variant') || root.dataset.initialVariant;
          update(id);
        });
      }
      function updateArrows() {
        if (!carousel) return;
        const maximum = carousel.scrollWidth - carousel.clientWidth;
        for (const arrow of arrows) arrow.disabled = Number(arrow.dataset.bathBrandDirection) < 0 ? carousel.scrollLeft < 2 : carousel.scrollLeft > maximum - 2;
      }
      for (const arrow of arrows) arrow.addEventListener('click', () => {
        const card = carousel?.querySelector('.seisso-bath-story__brand-card');
        const distance = (card?.getBoundingClientRect().width || 330) + 20;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        carousel?.scrollBy({ left: Number(arrow.dataset.bathBrandDirection) * distance, behavior });
      }, { signal });
      carousel?.addEventListener('scroll', updateArrows, { signal, passive: true });
      window.addEventListener('resize', updateArrows, { signal, passive: true });
      document.addEventListener('change', event => {
        const source = event.target.closest?.('[data-product-root]');
        if (source?.dataset.productId === root.dataset.productId) sync();
      }, { signal });
      window.addEventListener('popstate', sync, { signal });
      document.addEventListener('shopify:section:load', sync, { signal });
      sync();
      updateArrows();
      mounted.set(root, () => { controller.abort(); if (frame) cancelAnimationFrame(frame); });
    }
    function init(scope = document) {
      if (scope.matches?.('[data-bath-story]')) mount(scope);
      scope.querySelectorAll('[data-bath-story]').forEach(mount);
    }
    init();
    document.addEventListener('shopify:section:load', event => init(event.target));
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.matches?.('[data-bath-story]')) { mounted.get(event.target)?.(); mounted.delete(event.target); }
      event.target.querySelectorAll('[data-bath-story]').forEach(root => { mounted.get(root)?.(); mounted.delete(root); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seisso-creator-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('seisso-creator-videos')) {
    customElements.define('seisso-creator-videos', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.track = this.querySelector('[data-creator-track]');
        this.cards = Array.from(this.querySelectorAll('[data-creator-card]'));
        if (!this.track || !this.cards.length) return;
        this.videos = Array.from(this.querySelectorAll('[data-creator-video]'));
        this.previous = this.querySelector('[data-creator-prev]');
        this.next = this.querySelector('[data-creator-next]');
        this.counter = this.querySelector('[data-creator-counter]');
        this.announcement = this.querySelector('[data-creator-announcement]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = this.dataset.auto !== 'true';
        this.pointerActive = false;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.resumeAfter = 0;
        this.scrollFrame = 0;
        const signal = this.controller.signal;
        const on = (target, event, handler, options = {}) => target.addEventListener(event, handler, { ...options, signal });
        on(this.previous, 'click', () => { this.interact(); this.move(-1, true); });
        on(this.next, 'click', () => { this.interact(); this.move(1, true); });
        on(this, 'pointerenter', (event) => {
          if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); }
        });
        on(this, 'pointerleave', (event) => {
          if (event.pointerType !== 'touch') { this.hovered = false; this.interact(); }
        });
        on(this, 'pointerdown', () => { this.focused = false; this.pointerActive = true; this.interact(); }, { passive: true });
        on(window, 'pointerup', () => {
          if (this.pointerActive) { this.pointerActive = false; this.interact(); }
        }, { passive: true });
        on(window, 'pointercancel', () => {
          if (this.pointerActive) { this.pointerActive = false; this.interact(); }
        }, { passive: true });
        on(this, 'focusin', (event) => { this.focused = event.target.matches(':focus-visible'); this.interact(); });
        on(this, 'keydown', () => { this.focused = true; this.interact(); });
        on(this, 'focusout', () => {
          requestAnimationFrame(() => {
            if (!this.isConnected) return;
            this.focused = this.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
            this.interact();
          });
        });
        on(this.track, 'pointerdown', (event) => this.startDrag(event));
        on(window, 'pointermove', (event) => this.dragMove(event), { passive: false });
        on(window, 'pointerup', (event) => this.endDrag(event));
        on(window, 'pointercancel', (event) => this.endDrag(event));
        on(this.track, 'lostpointercapture', (event) => this.endDrag(event));
        on(this.track, 'click', (event) => {
          if (Date.now() < (this.dragSuppressUntil || 0)) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, { capture: true });
        on(this.track, 'wheel', () => this.interact(), { passive: true });
        on(this.track, 'scroll', () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = 0; this.updatePosition(); });
        }, { passive: true });
        on(this.track, 'keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.interact();
            this.move(event.key === 'ArrowRight' ? 1 : -1, true);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.interact();
            this.goTo(event.key === 'Home' ? 0 : this.maxScroll(), true);
          }
        });
        on(document, 'visibilitychange', () => {
          if (document.hidden) this.videos.forEach((video) => video.pause());
          this.schedule();
        });
        if (this.dataset.productContext === 'true') {
          on(document, 'play', (event) => {
            if (!(event.target instanceof HTMLVideoElement)) return;
            document.querySelectorAll('video').forEach((video) => {
              if (video !== event.target && !video.paused) video.pause();
            });
          }, { capture: true });
        }
        this.motionChange = () => { this.updateAuto(); this.schedule(); };
        this.motion.addEventListener('change', this.motionChange);
        this.querySelectorAll('[data-creator-play]').forEach((button) => {
          on(button, 'click', () => this.playVideo(button.closest('[data-creator-card]')));
        });
        this.videos.forEach((video) => {
          on(video, 'play', () => {
            this.videos.forEach((other) => { if (other !== video) other.pause(); });
            video.closest('[data-creator-card]').classList.add('is-playing');
            this.schedule();
          });
          on(video, 'pause', () => {
            video.closest('[data-creator-card]').classList.remove('is-playing');
            this.interact();
          });
          on(video, 'ended', () => {
            const card = video.closest('[data-creator-card]');
            card.classList.add('is-ended');
            card.classList.remove('is-playing');
            card.querySelector('[data-creator-play]').setAttribute('aria-label', this.dataset.replayLabel);
            card.querySelector('[data-creator-play-text]').textContent = this.dataset.replayLabel;
            this.interact();
          });
          on(video, 'error', () => this.videoError(video.closest('[data-creator-card]')));
        });
        this.observer = new IntersectionObserver((entries) => {
          this.visible = entries[0].isIntersecting;
          if (!this.visible) this.videos.forEach((video) => video.pause());
          this.schedule();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.cardObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio < 0.1) entry.target.querySelector('[data-creator-video]')?.pause();
          });
        }, { root: this.track, threshold: 0.1 });
        this.cards.forEach((card) => this.cardObserver.observe(card));
        this.resizeObserver = new ResizeObserver(() => { this.updateGeometry(); this.updatePosition(); this.schedule(); });
        this.resizeObserver.observe(this.track);
        on(document, 'shopify:block:select', (event) => {
          const card = this.cards.find((item) => item.dataset.blockId === event.detail.blockId);
          if (!card) return;
          this.userPaused = true;
          this.goTo(card.offsetLeft - this.cards[0].offsetLeft, false);
          this.updateAuto();
          this.schedule();
        });
        this.setAttribute('data-ready', '');
        this.updateGeometry();
        this.updateAuto();
        this.updatePosition();
        this.schedule();
      }

      disconnectedCallback() {
        this.dragState = null;
        this.classList.remove('is-dragging');
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.videos?.forEach((video) => video.pause());
        this.controller?.abort();
        this.observer?.disconnect();
        this.cardObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.motion?.removeEventListener('change', this.motionChange);
        this.controller = null;
      }

      maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }

      updateGeometry() {
        const media = this.cards[0]?.querySelector('.seisso-creator-videos__media');
        const viewport = this.querySelector('.seisso-creator-videos__viewport');
        if (media && viewport) this.style.setProperty('--creator-media-center', media.getBoundingClientRect().top - viewport.getBoundingClientRect().top + media.offsetHeight / 2 + 'px');
      }

      startDrag(event) {
        if (event.pointerType === 'touch' || event.button !== 0 || event.target.closest('a,video,input,button:not([data-creator-play])')) return;
        this.dragState = { id: event.pointerId, x: event.clientX, left: this.track.scrollLeft, active: false };
      }

      dragMove(event) {
        const drag = this.dragState;
        if (!drag || drag.id !== event.pointerId) return;
        const delta = event.clientX - drag.x;
        if (!drag.active && Math.abs(delta) < 8) return;
        if (!drag.active) {
          drag.active = true;
          this.classList.add('is-dragging');
          try { this.track.setPointerCapture(event.pointerId); } catch {}
        }
        event.preventDefault();
        this.track.scrollLeft = Math.max(0, Math.min(this.maxScroll(), drag.left - delta));
      }

      endDrag(event) {
        const drag = this.dragState;
        if (!drag || drag.id !== event.pointerId) return;
        this.dragState = null;
        const left = this.track.scrollLeft;
        this.classList.remove('is-dragging');
        if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
        if (!drag.active) return;
        this.dragSuppressUntil = Date.now() + 350;
        const step = Math.max(1, this.stepSize());
        this.goTo(Math.min(this.maxScroll(), Math.round(left / step) * step), true);
        this.interact();
      }

      stepSize() {
        if (this.cards.length < 2) return this.cards[0].getBoundingClientRect().width;
        return this.cards[1].getBoundingClientRect().left - this.cards[0].getBoundingClientRect().left;
      }

      position() {
        const step = Math.max(1, this.stepSize());
        const total = Math.max(1, Math.ceil((this.maxScroll() - 1) / step) + 1);
        const current = Math.min(total, Math.round(this.track.scrollLeft / step) + 1);
        return { current, total };
      }

      updatePosition() {
        const { current, total } = this.position();
        this.counter.textContent = `${String(current).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        this.style.setProperty('--creator-progress', String(total > 1 ? current / total : 1));
        const fixed = this.maxScroll() < 4;
        this.previous.disabled = fixed;
        this.next.disabled = fixed;
      }

      updateAuto() {
        this.toggleAttribute('data-user-paused', this.userPaused || this.motion.matches);
      }

      canRotate() {
        return this.isConnected && this.visible && !document.hidden && !this.userPaused && !this.motion.matches && !this.hovered && !this.focused && !this.pointerActive && this.maxScroll() > 4 && !this.videos.some((video) => !video.paused && !video.ended);
      }

      schedule() {
        clearTimeout(this.timer);
        this.dataset.rotationState = !this.visible ? 'offscreen' : document.hidden ? 'hidden' : this.userPaused ? 'paused' : this.motion.matches ? 'reduced-motion' : this.hovered ? 'hovered' : this.focused ? 'focused' : this.pointerActive ? 'interacting' : this.videos.some((video) => !video.paused && !video.ended) ? 'playing' : 'ready';
        if (!this.canRotate()) return;
        const delay = Math.max(6000, this.resumeAfter - Date.now());
        this.timer = setTimeout(() => {
          if (!this.canRotate()) return;
          this.move(1, false);
          this.schedule();
        }, delay);
      }

      interact() {
        this.resumeAfter = Date.now() + 12000;
        this.schedule();
      }

      move(direction, announce) {
        const max = this.maxScroll();
        const current = this.track.scrollLeft;
        let target = current + direction * this.stepSize();
        if (direction > 0 && current >= max - 4) target = 0;
        if (direction < 0 && current <= 4) target = max;
        this.goTo(Math.max(0, Math.min(max, target)), announce, target === 0 && direction > 0 && current >= max - 4 || target === max && direction < 0 && current <= 4);
      }

      goTo(left, announce, reset = false) {
        this.track.scrollTo({ left, behavior: reset || this.motion.matches ? 'auto' : 'smooth' });
        if (!announce) return;
        const step = Math.max(1, this.stepSize());
        const total = Math.max(1, Math.ceil((this.maxScroll() - 1) / step) + 1);
        const current = Math.min(total, Math.round(left / step) + 1);
        this.announcement.textContent = this.dataset.positionLabel.replace('__CURRENT__', String(current)).replace('__TOTAL__', String(total));
      }

      async playVideo(card) {
        const video = card.querySelector('[data-creator-video]');
        if (!video) return;
        this.interact();
        this.videos.forEach((other) => { if (other !== video) other.pause(); });
        card.querySelector('[data-creator-error]').hidden = true;
        card.classList.remove('is-ended');
        card.classList.add('is-loaded');
        this.videos.forEach((other) => {
          if (other === video || !other.getAttribute('src')) return;
          other.pause();
          other.removeAttribute('src');
          other.removeAttribute('poster');
          other.load();
          const previousCard = other.closest('[data-creator-card]');
          previousCard.classList.remove('is-loaded', 'is-playing', 'is-ended');
          previousCard.querySelector('[data-creator-error]').hidden = true;
          previousCard.querySelector('[data-creator-play]').setAttribute('aria-label', this.dataset.playLabel + ': ' + previousCard.querySelector('h3').textContent.trim());
          previousCard.querySelector('[data-creator-play-text]').textContent = this.dataset.playLabel;
        });
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.controls = true;
        video.muted = false;
        video.focus({ preventScroll: true });
        if (!video.getAttribute('src') || video.error) { video.src = video.dataset.src; video.load(); }
        if (video.ended) video.currentTime = 0;
        try { await video.play(); } catch (error) {
          if (error.name !== 'AbortError') this.videoError(card);
        }
      }

      videoError(card) {
        card.classList.remove('is-loaded', 'is-playing');
        const error = card.querySelector('[data-creator-error]');
        error.textContent = this.dataset.errorLabel;
        error.hidden = false;
        this.interact();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seisso-gift-offers"] && !Shopify.designMode) return;
  try {
    
(() => {
const GiftSeasons = (() => {
  const keys = ['newyear','valentine','easter','mothers','memorial','fathers','independence','labor','halloween','thanksgiving','blackfriday','christmas'];
  const blue = ['#3423bc','#8473f5','#160966'];
  const palettes = {
    brand: [['#294c42','#648a79','#173b31','#e8cc88','#f4dfaa']],
    newyear: [[...blue,'#eac771','#ffe9a2'],['#172441','#617494','#071127','#dde6f7','#f4e2ad'],['#d0a04d','#fff0b8','#6c4a20','#cc354e','#fff0b8']],
    valentine: [[...blue,'#ed446b','#ffdbc8'],['#e5a2ad','#ffe2e6','#b86074','#b3264b','#fff0c6'],['#7b243e','#c8738b','#421126','#eecb8c','#ffe0b1']],
    easter: [[...blue,'#9ecdbb','#fff0b3'],['#86ac93','#d5ecd3','#476752','#dba2b6','#fff0b3'],['#9873bd','#e8d7f7','#563b79','#efce73','#fff2c1']],
    mothers: [[...blue,'#ed9cbd','#fff0d5'],['#e8dbc5','#fffbef','#aa9175','#b95b80','#ffe9ba'],['#9e416e','#edafce','#59203e','#efd19e','#fff1ca']],
    memorial: [[...blue,'#d94350','#fff0c3'],['#e8e5d8','#fffdf6','#a9a597','#22335d','#ddbc75'],['#172e50','#5176a3','#071728','#d7b572','#ffe8a1']],
    fathers: [[...blue,'#be9869','#fff0c4'],['#2c5949','#6a927c','#102e23','#c28e57','#eac994'],['#34424b','#869ba8','#17212a','#667dd5','#e2e9ee']],
    independence: [[...blue,'#e73949','#fff0bf'],['#a6293e','#ed8190','#4c1222','#eee7d7','#ffe1a2'],['#e6e6db','#ffffff','#a29f91','#23417f','#efc878']],
    labor: [[...blue,'#e04b50','#f2dab0'],['#8c9fac','#dce5eb','#415568','#284aad','#f1dfb6'],['#16394c','#587c8d','#08242f','#c39a65','#eacf9d']],
    halloween: [[...blue,'#ed6240','#ffd694'],['#c96622','#ffbc73','#723713','#272340','#ffd184'],['#5b237d','#b577d1','#240d38','#ee7641','#fbd293']],
    thanksgiving: [[...blue,'#c8743d','#f6d38b'],['#b36632','#ecb66b','#67371c','#667252','#ffda9f'],['#2a5c4b','#74a086','#113226','#cb8758','#ffe0a5']],
    blackfriday: [[...blue,'#ed3b51','#ffe2a3'],['#293038','#737e8e','#0f1821','#deba77','#fff0c4'],['#73304d','#c57491','#351022','#9b9de3','#ffdcb0']],
    christmas: [[...blue,'#ed3948','#ffe3a4'],['#1b5f44','#6bab86','#083821','#dd3440','#ffe6a3'],['#8c2438','#d47689','#410d1d','#dab571','#fff0bf']]
  };
  const nthWeekday = (year, month, weekday, nth) => 1 + (weekday - new Date(Date.UTC(year,month-1,1)).getUTCDay()+7)%7 + 7*(nth-1);
  const lastWeekday = (year, month, weekday) => {const last=new Date(Date.UTC(year,month,0));return last.getUTCDate()-(last.getUTCDay()-weekday+7)%7;};
  const easter = year => {
    const a=year%19,b=Math.floor(year/100),c=year%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3);
    const h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),n=h+l-7*m+114;
    return [Math.floor(n/31),n%31+1];
  };
  const events = year => {
    const [em,ed]=easter(year),thanks=nthWeekday(year,11,4,4);
    return [ ['newyear',1,1,2],['valentine',2,14,0],['easter',em,ed,1],['mothers',5,nthWeekday(year,5,0,2),0],
      ['memorial',5,lastWeekday(year,5,1),0],['fathers',6,nthWeekday(year,6,0,3),0],['independence',7,4,0],
      ['labor',9,nthWeekday(year,9,1,1),0],['halloween',10,31,0],['thanksgiving',11,thanks,0],['blackfriday',11,thanks+1,3],['christmas',12,25,0] ]
      .map(([key,month,day,tail])=>({key,date:Date.UTC(year,month-1,day)/86400000,tail}));
  };
  const easternDate = now => {
    const fields=Object.fromEntries(new Intl.DateTimeFormat('en-US',{timeZone:'America/New_York',year:'numeric',month:'numeric',day:'numeric',hour:'numeric',hourCycle:'h23'}).formatToParts(now).map(part=>[part.type,part.value]));
    return {year:+fields.year,month:+fields.month,day:+fields.day,hour:+fields.hour};
  };
  const dailyOrder = (date,holiday) => {
    // A date-based shuffle is shared by every visitor and survives reloads.
    // Six permutations ensure each of the three styles appears exactly once.
    const seed=`seisso-gift-gift-8h-v1|${date}|${holiday}`;
    let hash=2166136261;
    for(let index=0;index<seed.length;index++)hash=Math.imul(hash^seed.charCodeAt(index),16777619)>>>0;
    hash=Math.imul(hash^(hash>>>16),0x7feb352d)>>>0;
    hash=Math.imul(hash^(hash>>>15),0x846ca68b)>>>0;
    hash=(hash^(hash>>>16))>>>0;
    return [[1,2,3],[1,3,2],[2,1,3],[2,3,1],[3,1,2],[3,2,1]][hash%6].slice();
  };
  const resolve = (config, now=new Date()) => {
    const date=easternDate(now),today=Date.UTC(date.year,date.month-1,date.day)/86400000;
    let holiday='brand';
    if(config.enabled!==false && config.mode!=='brand') {
      if(keys.includes(config.mode))holiday=config.mode;
      else {
        const enabled=config.holidays||keys,lead=Math.max(0,Math.min(30,Number(config.leadDays) || 0));
        const matches=[...events(date.year-1),...events(date.year),...events(date.year+1)]
          .filter(event=>enabled.includes(event.key)&&today>=event.date-lead&&today<=event.date+event.tail)
          .sort((a,b)=>Math.abs(a.date-today)-Math.abs(b.date-today));
        if(matches[0])holiday=matches[0].key;
      }
    }
    const dateKey=`${date.year}-${String(date.month).padStart(2,'0')}-${String(date.day).padStart(2,'0')}`;
    const order=dailyOrder(dateKey,holiday),slot=Math.min(2,Math.floor(date.hour/8));
    const style=config.variant||'auto8h';
    const variant=style==='auto8h'?(holiday==='brand'?1:order[slot]):style==='rotate'?today%3+1:Math.max(1,Math.min(3,Number(style)||1));
    return {holiday,variant,palette:palettes[holiday]?.[variant-1],date:dateKey,slot,order,automatic:style==='auto8h'};
  };
  const assetUrl = (root,chosen) => chosen.holiday==='brand'?root.dataset.dailyArtUrl:chosen.holiday==='halloween'?root.getAttribute('data-halloween-url-'+chosen.variant):root.getAttribute('data-sculpture-url-'+chosen.holiday+'-'+chosen.variant);
  const preload = (root,chosen) => {
    const url=assetUrl(root,chosen);
    if(!url)return Promise.resolve();
    // Request only artwork used by the active gift. Hidden lazy frames must
    // never gate the entrance: they may not load until after it is visible.
    const closed=chosen.holiday==='halloween'&&chosen.variant===1
      ?root.querySelector('.gift-halloween-closed-original'):null;
    const urls=[...new Set([url,closed?.getAttribute('src')].filter(Boolean))];
    return Promise.all(urls.map(source=>{
      const link=document.createElement('link');
      link.rel='preload';link.as='image';link.href=source;link.fetchPriority='low';
      document.head.append(link);
      const image=new Image();image.loading='eager';image.fetchPriority='low';image.src=source;
      return image.decode().finally(()=>link.remove());
    }));
  };
  const apply = (root,config,now) => {
    const chosen=resolve(config,now);root.dataset.holiday=chosen.holiday;root.dataset.skin=String(chosen.variant);root.dataset.holidayDate=chosen.date;
    root.dataset.seasonSlot=String(chosen.slot);root.dataset.seasonOrder=chosen.order.join(',');root.dataset.seasonRotation=chosen.automatic?'8h':'manual';
    root.dataset.sculpture=String(chosen.holiday!=='brand' && !!assetUrl(root,chosen));
    if(assetUrl(root,chosen)) {
      const url=assetUrl(root,chosen);
      root.querySelectorAll('[data-halloween-image]').forEach(image=>{if(url && image.getAttribute('src')!==url)image.src=url;});
    }
    if(chosen.palette) {
      ['body','light','dark','ribbon','gold'].forEach((key,index)=>root.style.setProperty('--gift-'+key,chosen.palette[index]));
      root.querySelectorAll('[data-holiday-icon]').forEach(use=>use.setAttribute('href',`#GiftIcon-${root.dataset.iconId}-${chosen.holiday}`));
    } else ['body','light','dark','ribbon','gold'].forEach(key=>root.style.removeProperty('--gift-'+key));
    return chosen;
  };
  return {keys,palettes,events,easternDate,dailyOrder,resolve,assetUrl,preload,apply};
})();


// The opening is measured on each artwork, in the 340 × 640 stage.
// A matching foreground rim and pocket mask keep the card inside the vessel.
const GiftMouth = (() => {
  const profiles = {"brand":[[166.1,433,109.2,14.72],[166.1,433,109.2,14.72],[166.1,433,109.2,14.72]],"halloween":[[168,431,69,17],[169,448.5,91,31],[170,450,115,30]],"christmas":[[170,442,108,26],[170,452,110,34],[170,438,82,22]],"newyear":[[170,448,108,31],[170,440,94,24],[170,445,126,28]],"valentine":[[170,453,97,34],[170,439,108,24],[170,451,108,31]],"easter":[[170,444,110,28],[170,439,123,24],[170,444,117,28]],"mothers":[[170,451,111,31],[170,448,122,31],[170,440,108,24]],"memorial":[[170,445,115,29],[170,449,103,32],[170,450,139,32]],"fathers":[[170,457,130,22],[170,450,124,33],[170,454,94,37]],"independence":[[170,451,102,31],[170,438,85,22],[170,448,111,31]],"labor":[[170,444,136,27],[170,449,107,32],[170,451,105,32]],"thanksgiving":[[170,450,99,31],[170,439,108,24],[170,445,91,29]],"blackfriday":[[170,444,119,26],[170,445,123,26],[170,447,122,30]]};
  const clamp = value => Math.max(0,Math.min(1,value));
  const smooth = value => { const p=clamp(value);return p*p*(3-2*p); };
  const polygon = points => `polygon(${points.map(([x,y])=>`${x.toFixed(2)}px ${y.toFixed(2)}px`).join(',')})`;
  const prepare = root => {
    const pocket=root.querySelector('.gift-pocket'),front=root.querySelector('.gift-front');
    let key='',geometryKey='',mouth;
    return (ticket,progress,floatY) => {
      const selected=`${root.dataset.holiday}|${root.dataset.skin}`;
      if(selected!==key) {
        key=selected;
        mouth=(profiles[root.dataset.holiday]||profiles.brand)[Math.max(0,Math.min(2,Number(root.dataset.skin)-1||0))];
        const [cx,cy,rx,ry]=mouth;
        const arc=Array.from({length:33},(_,i)=>{const angle=Math.PI*i/32;return [cx+rx*Math.cos(angle),cy+ry*Math.sin(angle)];});
        pocket.style.clipPath=polygon([[0,0],[340,0],[340,cy],...arc,[0,cy]]);
        root.dataset.mouth=mouth.join(',');
      }
      // Hidden gifts have zero layout dimensions. Never cache their mask;
      // recalculate from the actual foreground when it becomes measurable.
      const width=ticket.offsetWidth,height=ticket.offsetHeight;
      if(!front.offsetWidth || !front.offsetHeight || !width || !height) {
        geometryKey='';ticket.style.opacity='0';return;
      }
      const style=getComputedStyle(front);
      const geometry=[selected,front.offsetLeft,front.offsetTop,front.offsetWidth,front.offsetHeight,style.transform,style.transformOrigin].join('|');
      if(geometry!==geometryKey) {
        const [cx,cy,rx,ry]=mouth;
        const arc=Array.from({length:33},(_,i)=>{const angle=Math.PI*i/32;return [cx+rx*Math.cos(angle),cy+ry*Math.sin(angle)];});
        const rim=[[front.offsetLeft,cy],...arc.slice().reverse(),[front.offsetLeft+front.offsetWidth,cy],
          [front.offsetLeft+front.offsetWidth,front.offsetTop+front.offsetHeight],[front.offsetLeft,front.offsetTop+front.offsetHeight]];
        const matrix=new DOMMatrix(style.transform);
        const [ox,oy]=style.transformOrigin.split(' ').map(Number.parseFloat);
        const left=front.offsetLeft+ox*(1-matrix.a)+matrix.e;
        const top=front.offsetTop+oy*(1-matrix.d)+matrix.f;
        front.style.clipPath=polygon(rim.map(([x,y])=>[(x-left)/matrix.a,(y-top)/matrix.d]));
        geometryKey=geometry;
      }
      const [cx,cy,rx,ry]=mouth;
      const initialScale=Math.min(.44,Math.max(.28,(2*rx-16)/width));
      const lip=cy+ry,startBottom=lip+height*initialScale+14;
      const endBottom=Math.min(ticket.offsetTop+height,cy-12);
      const bottom=startBottom+(endBottom-startBottom)*progress;
      // Expand only after the upper portion has cleared the opening.
      const expandStart=lip+height*initialScale*.4,expandEnd=cy-8;
      const expansion=smooth((expandStart-bottom)/(expandStart-expandEnd));
      const scale=initialScale+(1-initialScale)*expansion;
      const finalX=ticket.offsetLeft+width/2;
      const center=cx;
      ticket.style.opacity=progress>0?'1':'0';
      ticket.style.transform=`translate(${center-finalX}px,${bottom-ticket.offsetTop-height+floatY}px) scale(${scale})`;
      root.dataset.cardScale=String(scale);root.dataset.cardBottom=String(bottom);
    };
  };
  return {prepare};
})();

  const initialize = root => {
    if (!root || root.dataset.ready === 'true') return;
    const stage = root.querySelector('[data-coupon-stage]');
    const body = root.querySelector('[data-gift-body]');
    const lid = root.querySelector('.gift-lid');
    const seal = root.querySelector('.gift-seal');
    const ticket = root.querySelector('[data-coupon-ticket]');
    const renderCard = GiftMouth.prepare(root);
    const slides = [...root.querySelectorAll('[data-coupon-slide]')];
    const dots = [...root.querySelectorAll('[data-gift-dot]')];
    const pause = root.querySelector('[data-coupon-pause]');
    const toggle = root.querySelector('[data-gift-toggle]');
    const dismiss = root.querySelector('[data-coupon-dismiss]');
    const modal = document.getElementById(slides[0]?.getAttribute('aria-controls'));
    if (!stage || !body || !lid || !seal || !slides.length || !modal) return;
    const mobile = matchMedia('(max-width:749px)');
    const wide = matchMedia('(min-width:1800px) and (min-height:720px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const designer = root.dataset.designMode === 'true';
    const seasonConfig = {enabled:root.dataset.seasonEnabled==='true',mode:root.dataset.seasonMode,variant:root.dataset.seasonVariant,leadDays:Number(root.dataset.seasonLead),holidays:root.dataset.seasonHolidays.split(',').filter(Boolean)};
    const artworkReady = GiftSeasons.preload(root,GiftSeasons.resolve(seasonConfig));
    GiftSeasons.apply(root,seasonConfig);
    let nextSeasonCheck = Math.floor(Date.now()/30000)*30000+30000;
    let seasonSwapPending = false;
    const desktopSize = Math.max(.8,Math.min(1.1,Number(root.dataset.desktopSize)/100 || 1));
    const mobileSize = Math.max(.8,Math.min(1.1,Number(root.dataset.mobileSize)/100 || 1));
    const welcome = document.getElementById('SeissoWelcomePopup');
    const welcomeOpen = () => Boolean(welcome && !welcome.hidden);
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const save = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
    // SEISSO_FB_QUIET_V1: preserve a closed, clickable gift throughout a paid-social session.
    const paidSocialQuietKey = 'seisso-paid-social-quiet-v1';
    const query = new URLSearchParams(location.search);
    const paidSource = /^(facebook|fb|instagram|ig|meta)$/i.test(query.get('utm_source') || '');
    const paidMedium = /^(paid_social|paid-social|cpc|ppc)$/i.test(query.get('utm_medium') || '');
    const paidSocialLanding = query.get('ad_landing') === '1' || query.has('fbclid') || (paidSource && paidMedium);
    if (paidSocialLanding) save(paidSocialQuietKey, 'true');
    const paidSocialQuiet = !designer && (paidSocialLanding || read(paidSocialQuietKey) === 'true');
    root.dataset.paidSocialQuiet = String(paidSocialQuiet);

    const prefix = 'seisso-gift-gift-cycle-';
    const visit = prefix + 'visit-v2-';
    const customer = root.dataset.customer || 'guest';
    if (read(visit + 'customer') && read(visit + 'customer') !== customer) {
      save(visit + 'closes', '0'); save(visit + 'until', '0'); save(visit + 'runtime-v4','');
    }
    save(visit + 'customer', customer);
    let closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
    let snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
    let dockPosition = null;
    try { dockPosition = JSON.parse(read(visit + 'dock')); } catch {}
    if (!dockPosition || !['left','right'].includes(dockPosition.side) || !Number.isFinite(dockPosition.anchor)) dockPosition = null;
    const home = document.createComment('SEISSO gift home');
    root.before(home);
    let cartHost = null;
    let keyboardIntent = false;
    let idleShakeBand = 0;
    const arrival = Number(read(prefix + 'arrival')) || Date.now() - performance.now();
    save(prefix + 'arrival', String(arrival));
    const modulo = (value, length) => ((value % length) + length) % length;
    const clamp = value => Math.max(0, Math.min(1, value));
    const smooth = value => { const p = clamp(value); return p * p * (3 - 2 * p); };
    const mix = (from, to, progress) => from + (to - from) * progress;
    const interval = Math.max(2000, Number(root.dataset.rotationMs) || 2000);
    const stageHeight = 640;
    const closedCut = 394;
    let cycle = 'waiting';
    let elapsed = 0;
    let layout = mobile.matches ? 'center' : 'featured';
    let placement = null;
    let placementMotion = null;
    let progressLid = 0;
    let progressPanel = 0;
    let returnPose = { lid: 1, panel: 1 };
    let phase = 0;
    let turn = null;
    let nextTurn = interval;
    const minimumExposure = Math.max(1000, interval - 640);
    let exposure = slides.map(() => 0);
    const offerSignature = slides.map(slide => slide.getAttribute('aria-label')).join('|');
    const allShown = () => exposure.every(time => time >= minimumExposure);
    const readRuntime = () => {
      try {
        const value = JSON.parse(read(visit + 'runtime-v4'));
        if (value?.version !== 4 || value.customer !== customer || value.offers !== offerSignature
          || !['waiting','dropping','opening','showing','retracting','shaking','closed','snoozed','dismissed'].includes(value.cycle)
          || !Number.isFinite(value.phase) || !Number.isFinite(value.elapsed) || value.elapsed < 0) return null;
        return value;
      } catch { return null; }
    };
    let manualPaused = false;
    let held = null;
    let suppressUntil = 0;
    let blocked = false;
    let assetsReady = false;
    let welcomeWasOpen = welcomeOpen();
    let welcomeClosed = paidSocialQuiet || designer || !welcome || (read('seisso-welcome-home-shown') === 'true' && !welcomeOpen() && performance.getEntriesByType('navigation')[0]?.type !== 'reload');
    let disposed = false;
    let dismissed = closeCount >= 2;
    let lastTime = performance.now();
    let frame = null;
    let dropCount = 0;
    let openCount = 0;
    let shakeCount = 0;
    let geometryKey = '';
    let slideKey = '';
    const particles = [];
    const canvas = root.querySelector('[data-coupon-confetti]');
    const context = canvas?.getContext('2d');
    let burstCount = 0;
    let confettiTime = 0;
    const dimensions = () => {
      const viewport = visualViewport;
      const width = viewport?.width || innerWidth;
      const height = viewport?.height || innerHeight;
      const left = viewport?.offsetLeft || 0;
      const top = viewport?.offsetTop || 0;
      const header = Math.max(top, Math.min(top + height - 100, document.querySelector('.site-header')?.getBoundingClientRect().bottom || top));
      return { width, height, left, top, header };
    };
    const targetPlacement = kind => {
      const view = dimensions();
      if (mobile.matches) {
        const headroom=110;
        if (kind === 'dock') {
          const scale = .28 * mobileSize;
          const anchor = dockPosition ? view.top + dockPosition.anchor * view.height : view.header + 18 + (stageHeight+headroom) * scale;
          return { scale, left: view.left + (dockPosition?.side === 'right' ? view.width - 340 * scale - 14 : 14), anchor: Math.max((headroom?view.header:view.top) + (stageHeight+headroom) * scale + 22, Math.min(view.top + view.height - 12, anchor)) };
        }
        const scale = Math.max(.3, Math.min(.88 * mobileSize, (view.width - 40) / 340, (view.height - (view.header - view.top) - 34) / (stageHeight + (headroom||40))));
        const height = (stageHeight - closedCut * (1 - Math.max(progressLid, progressPanel))) * scale;
        return { scale, left: view.left + (view.width - 340 * scale) / 2, anchor: view.top + Math.max((view.height - height) / 2, view.header - view.top + 14 + (headroom||40) * scale) + height };
      }
      const scale = kind === 'dock' ? .40 * desktopSize : Math.max(.3, Math.min((wide.matches ? 232 / 340 : .56) * desktopSize, (view.height - (view.header - view.top) - 38) / stageHeight));
      const width = 340 * scale;
      return { scale, left: wide.matches ? Math.max(12, (view.width - 1360) / 4 - width / 2) : 12, anchor: view.top + view.height - 52 };
    };
    const place = (kind, animate = true) => {
      const target = targetPlacement(kind);
      layout = kind;
      root.dataset.layout = kind;
      toggle.setAttribute('aria-expanded', String(kind !== 'dock'));
      if (!placement || !animate || reduced.matches) { placement = target; placementMotion = null; }
      else placementMotion = { from: { ...placement }, to: target, time: 0, duration: 720 };
      lastTime = performance.now();
    };
    const selectCycle = next => {
      cycle = next;
      elapsed = 0;
      root.dataset.cycle = next;
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(next) ? next : layout === 'dock' ? 'docked' : mobile.matches ? 'center' : 'desktop';
      if (next === 'dropping') { dropCount += 1; root.dataset.startedAt = String(performance.now()); }
      if (next === 'opening') { openCount += 1; root.dataset.openedAt = String(performance.now()); burst(); }
      if (next === 'showing') { root.dataset.showingAt = String(performance.now()); nextTurn = interval; exposure = slides.map(() => 0); }
      if (next === 'shaking') shakeCount += 1;
      if (next === 'closed') { root.dataset.closedAt = String(performance.now()); idleShakeBand = 0; }
    };
    const keyboardPaused = () => cycle === 'showing' && keyboardIntent && root.contains(document.activeElement) && document.activeElement?.matches(':focus-visible') && document.activeElement !== pause;
    const frozen = () => blocked || modal.open || Boolean(held) || manualPaused || keyboardPaused();
    const paintSlides = () => {
      const current = modulo(Math.round(phase), slides.length);
      const key = `${phase.toFixed(5)}|${cycle}|${layout}|${mobile.matches}`;
      if (key === slideKey) return;
      slideKey = key;
      slides.forEach((slide, index) => {
        const offset = modulo(phase - index + slides.length / 2, slides.length) - slides.length / 2;
        const angle = Math.max(-1, Math.min(1, offset)) * Math.PI / 2;
        const radius = ticket.clientWidth / 2;
        slide.style.transform = `translate3d(${-radius * Math.sin(angle)}px,0,${radius * (Math.cos(angle) - 1)}px) rotateY(${-offset * 90}deg)`;
        slide.style.opacity = String(clamp((1 - Math.abs(offset)) / .18));
        slide.style.setProperty('--turn-shade', String(Math.min(1, Math.abs(offset)) * .35));
        slide.classList.toggle('is-current', current === index);
        slide.setAttribute('aria-hidden', String(index !== current || cycle !== 'showing'));
        slide.tabIndex = current === index && cycle === 'showing' && !(mobile.matches && layout === 'dock') ? 0 : -1;
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(current === index)));
      root.querySelector('[data-coupon-position]').textContent = String(current + 1);
      root.dataset.current = String(current);
    };
    const navigate = steps => {
      if (cycle !== 'showing') return;
      const target = Math.round(phase) + steps;
      if (reduced.matches) { phase = target; turn = null; }
      else turn = { from: phase, to: target, time: 0, duration: 640 };
      nextTurn = interval;
      paintSlides();
    };
    const advanceCarousel = delta => {
      if (cycle !== 'showing' || frozen()) return;
      let stableTime = delta;
      if (turn) {
        stableTime = Math.max(0, delta - (turn.duration - turn.time));
        turn.time = Math.min(turn.duration, turn.time + delta);
        phase = mix(turn.from, turn.to, smooth(turn.time / turn.duration));
        if (turn.time >= turn.duration) { phase = turn.to; turn = null; }
      }
      if (!turn && Math.abs(phase - Math.round(phase)) < .001) {
        const current = modulo(Math.round(phase), slides.length);
        exposure[current] = Math.min(minimumExposure, exposure[current] + stableTime);
      }
      if (designer && allShown()) exposure=slides.map(()=>0);
      if (reduced.matches || allShown()) return;
      nextTurn -= delta;
      if (nextTurn <= 0 && !turn && exposure[modulo(Math.round(phase), slides.length)] >= minimumExposure) { navigate(1); nextTurn = interval; }
    };
    const burst = () => {
      if (!context || reduced.matches || designer || root.dataset.confettiEnabled !== 'true') return;
      burstCount += 1;
      const dpr = Math.min(devicePixelRatio || 1, 2);
      canvas.width = 460 * dpr; canvas.height = 820 * dpr;
      context.setTransform(dpr, 0, 0, dpr, 0, 0);
      const colors = ['#294c42', '#77978a', '#e8cc88', '#cbbd9e', '#f3e7cd'];
      particles.length=0;
      const count=mobile.matches?180:260;
      for(let index=0;index<count;index+=1){
        const rain=index%2===0,side=index%4<2?-1:1;
        particles.push({source:rain?'top':'bottom',x:rain?Math.random()*340:170+side*(72+Math.random()*36),y:rain?-270+Math.random()*140:454,
          vx:rain?(Math.random()-.5)*65:side*(40+Math.random()*130),vy:rain?90+Math.random()*100:-(560+Math.random()*170),gravity:rain?145:580,
          color:colors[index%colors.length],width:index%3?4:2.5,length:index%3?8:22+Math.random()*18,ribbon:index%3===0,
          spin:(Math.random()-.5)*8,seed:Math.random()*6,born:Math.random()*(rain?500:160),life:rain?3300+Math.random()*350:2900+Math.random()*350});
      }
      confettiTime = 0;
    };
    const paintConfetti = delta => {
      if (!context || !particles.length) return;
      if (blocked || reduced.matches) { particles.length = 0; context.clearRect(0, 0, 460, 820); return; }
      confettiTime += delta;
      context.clearRect(0, 0, 460, 820);
      for (let index = particles.length - 1; index >= 0; index -= 1) {
        const p = particles[index];
        const age = confettiTime - p.born;
        if (age > p.life) { particles.splice(index, 1); continue; }
        if (age < 0) continue;
        const dt = Math.min(.045, delta / 1000);
        p.vy += p.gravity * dt; p.vx *= Math.exp(-.6 * dt);
        p.x += p.vx * dt; p.y += p.vy * dt;
        context.save(); context.translate(p.x + 60, p.y + 340); context.rotate(age / 1000 * p.spin);
        context.globalAlpha = clamp((p.life - age) / 550); context.fillStyle = p.color; context.strokeStyle = p.color;
        if (p.ribbon) { context.beginPath(); for (let n = 0; n <= 12; n += 1) { const x = Math.sin(n * .85 + age / 250 + p.seed) * 4; const y = (n / 12 - .5) * p.length; if (n === 0) context.moveTo(x, y); else context.lineTo(x, y); } context.lineWidth = p.width; context.stroke(); }
        else context.fillRect(-p.width / 2, -p.length / 2, p.width, p.length);
        context.restore();
      }
      root.dataset.confettiActive=String(particles.length);root.dataset.confettiTop=String(particles.filter(p=>p.source==='top').length);root.dataset.confettiBottom=String(particles.filter(p=>p.source==='bottom').length);
    };
    const beginReturn = () => {
      if (['waiting','dismissed','retracting','shaking','closed'].includes(cycle)) return;
      returnPose = { lid: progressLid, panel: progressPanel };
      selectCycle('retracting');
      lastTime = performance.now();
    };
    const duration = () => {
      if (reduced.matches) return cycle === 'showing' || cycle === 'closed' ? Infinity : 0;
      return ({ dropping: 1100, opening: 1150, showing: Infinity, retracting: 1050, shaking: 650, closed: paidSocialQuiet ? Infinity : 30000 })[cycle] ?? Infinity;
    };
    const finishChapter = () => {
      if (cycle === 'dropping') { selectCycle('opening'); }
      else if (cycle === 'opening') selectCycle('showing');
      else if (cycle === 'showing') { returnPose = { lid: 1, panel: 1 }; selectCycle('retracting'); }
      else if (cycle === 'retracting') { place('dock'); selectCycle('shaking'); }
      else if (cycle === 'shaking') selectCycle('closed');
      else if (cycle === 'closed') { if (!mobile.matches && layout === 'dock') place('featured'); selectCycle('opening'); }
    };
    const advanceCycle = delta => {
      let remaining = delta;
      for (let attempts = 0; attempts < 12; attempts += 1) {
        const length = duration();
        const portion = Math.min(remaining, Math.max(0, length - elapsed));
        advanceCarousel(portion);
        elapsed += portion; remaining -= portion;
        if (cycle === 'showing' && allShown() && !turn && !designer) { finishChapter(); break; }
        if (elapsed < length || !Number.isFinite(length)) break;
        finishChapter();
        if (placementMotion || remaining <= 0 && duration() > 0) break;
      }
    };
    const render = () => {
      let dropY = 0, dropAngle = 0, shakeX = 0, shakeAngle = 0;
      if (cycle === 'opening') { progressLid = reduced.matches ? 1 : smooth(elapsed / 850); progressPanel = reduced.matches ? 1 : smooth((elapsed - 380) / 750); }
      else if (cycle === 'showing') { progressLid = 1; progressPanel = 1; }
      else if (cycle === 'retracting') { progressLid = returnPose.lid * (1 - smooth((elapsed - 350) / 700)); progressPanel = returnPose.panel * (1 - smooth(elapsed / 600)); }
      else { progressLid = 0; progressPanel = 0; }
      if (cycle === 'dropping') {
        const progress = clamp(elapsed / 1100);
        if (progress < .72) { const p = progress / .72; dropY = -(innerHeight / placement.scale + stageHeight) * (1 - p * p); dropAngle = -6 * (1 - p); }
        else if (progress < .9) { const p = (progress - .72) / .18; dropY = -23 * Math.sin(p * Math.PI); dropAngle = Math.sin(p * Math.PI) * 1.6; }
        root.dataset.dropProgress = String(progress);
      }
      const idleBand = Math.floor(elapsed / 5000);
      const idleTime = elapsed % 5000;
      const idleShake = cycle === 'closed' && idleBand > 0 && idleTime < 650;
      if (cycle === 'closed' && !reduced.matches && idleBand > idleShakeBand) { shakeCount += idleBand - idleShakeBand; idleShakeBand = idleBand; }
      const shaking = cycle === 'shaking' || idleShake;
      if (shaking && !reduced.matches) { const p = clamp((idleShake ? idleTime : elapsed) / 650); const wave = Math.sin(p * Math.PI * 8) * (1 - p) ** 2; shakeX = wave * 4 / placement.scale; shakeAngle = wave * 4; }
      root.dataset.shaking = String(shaking && !reduced.matches);
      body.style.transform = `translate(${shakeX}px,${dropY}px) rotate(${dropAngle + shakeAngle}deg)`;
      body.style.filter = cycle === 'shaking' ? `drop-shadow(0 0 ${10 * (1 - elapsed / 650)}px #6a58fc50)` : 'none';
      const sealOpacity = smooth((.24 - progressLid) / .24);
      seal.style.opacity = String(sealOpacity);
      root.style.setProperty('--gift-shell-open', String(1-sealOpacity));
      lid.style.opacity = String(1 - sealOpacity);
      lid.style.transform = `translateY(${mix(335, -98, progressLid)}px) rotate(${mix(8, -2, progressLid)}deg)`;
      const floatY = cycle === 'showing' && !reduced.matches ? Math.sin(elapsed / 1200) * 2 : 0;
      renderCard(ticket,progressPanel,floatY);
      root.style.setProperty('--gift-panel', String(progressPanel));
      root.style.setProperty('--gift-shadow-scale', String(1 - floatY / 60));
      const cut = closedCut * (1 - Math.max(progressLid, progressPanel));
      if (mobile.matches && layout === 'center' && !placementMotion) placement.anchor = targetPlacement('center').anchor;
      const width = 340 * placement.scale;
      const height = (stageHeight - cut) * placement.scale;
      const top = placement.anchor - height;
      const key = [width,height,top,placement.left,cut].map(n => n.toFixed(3)).join('|');
      if (key !== geometryKey) {
        geometryKey = key;
        root.style.setProperty('--gift-left', `${placement.left}px`); root.style.setProperty('--gift-top', `${top}px`);
        root.style.setProperty('--gift-width', `${width}px`); root.style.setProperty('--gift-height', `${height}px`);
        root.style.setProperty('--gift-scale', String(placement.scale)); root.style.setProperty('--gift-offset', `${-cut * placement.scale}px`);
      }
      root.dataset.layout = layout;
      root.dataset.state = ['waiting','snoozed','dismissed'].includes(cycle) ? cycle : dismissed ? 'dismissed' : layout === 'dock' ? 'docked' : mobile.matches ? 'center' : 'desktop';
      root.dataset.cycle = cycle; root.dataset.cycleElapsed = String(elapsed); root.dataset.lidProgress = String(progressLid); root.dataset.panelProgress = String(progressPanel);
      root.dataset.offersSeen = String(exposure.filter(time => time >= minimumExposure).length); root.dataset.offersTotal = String(slides.length); root.dataset.exposure = JSON.stringify(exposure);
      root.dataset.phase = String(phase); root.dataset.displayedPhase = String(phase); root.dataset.moving = String(Boolean(turn));
      root.dataset.closeWait = String(cycle === 'closed' ? 30000 - elapsed : 0);
      root.dataset.openCount = String(openCount); root.dataset.dropCount = String(dropCount); root.dataset.shakes = String(shakeCount); root.dataset.bursts = String(burstCount);
      root.dataset.confettiActive=String(particles.length);
      root.dataset.placing = String(Boolean(placementMotion)); root.dataset.held = String(Boolean(held));
      pause.setAttribute('aria-pressed', String(manualPaused || reduced.matches)); pause.setAttribute('aria-label', manualPaused || reduced.matches ? pause.dataset.playLabel : pause.dataset.pauseLabel);
      const sealed = cycle === 'closed' || cycle === 'shaking';
      dismiss.setAttribute('aria-label', sealed ? closeCount ? 'Hide gift offers for this visit' : 'Hide gift offers for 5 minutes' : dismiss.dataset.minimizeLabel);
      dismiss.title = dismiss.getAttribute('aria-label');
      root.dataset.closeCount = String(closeCount); root.dataset.snoozeUntil = String(snoozeUntil);
      root.dataset.dockSide = dockPosition?.side || 'left';
      paintSlides();
    };
    // A modal cart makes the page inert. Keep the gift inside that modal, and
    // use the browser's top layer so the drawer cannot clip the floating gift.
    const syncCartLayer = () => {
      const cart = document.querySelector('dialog[data-cart-drawer][open]');
      const visible = !blocked && !dismissed && !['waiting','snoozed'].includes(cycle) && !modal.open;
      if (cartHost !== cart) {
        if (root.hasAttribute('popover')) {
          if (root.matches(':popover-open')) root.hidePopover();
          root.removeAttribute('popover');
        }
        cartHost = cart;
        if (cart) { cart.append(root); if (typeof root.showPopover === 'function') root.setAttribute('popover','manual'); }
        else if (home.isConnected) home.after(root);
      }
      if (root.hasAttribute('popover')) {
        if (visible && !root.matches(':popover-open')) root.showPopover();
        else if (!visible && root.matches(':popover-open')) root.hidePopover();
      }
      root.dataset.inCart = String(Boolean(cart));
    };
    const availability = () => {
      if (welcomeOpen()) welcomeWasOpen = true;
      else if (welcomeWasOpen) welcomeClosed = true;
      const previous = blocked;
      blocked = !welcomeClosed || document.hidden || [...document.querySelectorAll('dialog[open]')].some(dialog => dialog !== modal && !(designer && dialog===welcome) && !dialog.matches('[data-cart-drawer]')) || welcomeOpen() || Boolean(document.querySelector('.mobile-drawer[open]'));
      root.dataset.blocked = String(blocked);
      root.inert = blocked || dismissed || ['waiting','snoozed'].includes(cycle);
      syncCartLayer();
      if (previous !== blocked) lastTime = performance.now();
    };
    const restoreSnoozed = () => {
      snoozeUntil = 0; save(visit + 'until','0');
      manualPaused = false; held = null; turn = null;
      progressLid = 0; progressPanel = 0;
      place('dock',false); selectCycle('closed'); availability(); render();
    };
    const safeSeasonSwap = () => !held && !modal.open && !placementMotion && ['waiting','closed','snoozed','dismissed'].includes(cycle);
    const refreshSeason = async () => {
      if(disposed || seasonSwapPending)return;
      const next=GiftSeasons.resolve(seasonConfig);
      if(next.holiday===root.dataset.holiday && String(next.variant)===root.dataset.skin){GiftSeasons.apply(root,seasonConfig);return;}
      if(!safeSeasonSwap())return;
      seasonSwapPending=true;
      try{
        // Decode the next sculpted skin before atomically replacing the four frames.
        const url=GiftSeasons.assetUrl(root,next);
        await GiftSeasons.preload(root,next);
        if(!disposed && safeSeasonSwap() && GiftSeasons.assetUrl(root,GiftSeasons.resolve(seasonConfig))===url)GiftSeasons.apply(root,seasonConfig);
      }catch{/* Keep the current gift when a replacement asset cannot load. */}
      finally{seasonSwapPending=false;}
    };
    const tick = now => {
      if (disposed) return;
      const delta = Math.max(0, now - lastTime); lastTime = now;
      if(Date.now()>=nextSeasonCheck){nextSeasonCheck=Math.floor(Date.now()/30000)*30000+30000;refreshSeason();}
      if (cycle === 'snoozed' && Date.now() >= snoozeUntil && !dismissed) restoreSnoozed();
      if (!dismissed && cycle !== 'snoozed' && assetsReady) {
        if (cycle === 'waiting' && !blocked && welcomeClosed) {
          place(mobile.matches ? 'center' : 'featured', false); selectCycle(designer?'opening':'dropping'); root.inert = false;
        }
        if (placementMotion && !blocked && !modal.open && !held) {
          if (placementMotion.openOnMove && !frozen()) {
            advanceCycle(delta);
            placementMotion.to = targetPlacement(layout);
          }
          placementMotion.time += delta;
          const p = smooth(placementMotion.time / placementMotion.duration);
          placement = { scale: mix(placementMotion.from.scale,placementMotion.to.scale,p), left: mix(placementMotion.from.left,placementMotion.to.left,p), anchor: mix(placementMotion.from.anchor,placementMotion.to.anchor,p) };
          if (placementMotion.time >= placementMotion.duration) { placement = placementMotion.to; placementMotion = null; }
        } else if (cycle !== 'waiting' && !frozen() && !placementMotion) advanceCycle(delta);
        render(); paintConfetti(delta); syncCartLayer();
      }
      frame = requestAnimationFrame(tick);
    };
    const expand = () => {
      if (dismissed || blocked || cycle === 'snoozed' || layout !== 'dock') return;
      root.dataset.expandPhase = String(phase); root.dataset.expandCycle = cycle; root.dataset.expandElapsed = String(elapsed);
      const closed = cycle === 'closed' || cycle === 'shaking';
      if (closed) { manualPaused = false; selectCycle('opening'); }
      place(mobile.matches ? 'center' : 'featured');
      if (closed && placementMotion) placementMotion.openOnMove = true;
      render();
    };
    const openPanel = index => {
      if (dismissed || blocked || ['waiting','snoozed'].includes(cycle)) return;
      modal.querySelectorAll('[data-coupon-offer]').forEach((offer, n) => offer.dataset.selected = String(n === modulo(index ?? Math.round(phase), slides.length)));
      if (!modal.open) modal.showModal(); lastTime = performance.now();
    };
    const allowClick = event => event.detail === 0 || Date.now() >= suppressUntil;
    root.addEventListener('click', event => {
      if (!allowClick(event)) { event.preventDefault(); event.stopImmediatePropagation(); return; }
      if (layout === 'dock' && !event.target.closest('[data-coupon-dismiss]')) { event.preventDefault(); event.stopImmediatePropagation(); expand(); }
    }, { ...options, capture: true });
    slides.forEach((slide,index) => slide.addEventListener('click', () => openPanel(index), options));
    toggle.addEventListener('click', () => {
      if (layout === 'dock') expand();
      else if (cycle === 'closed' || cycle === 'shaking') { manualPaused = false; selectCycle('opening'); render(); }
      else openPanel();
    }, options);
    root.querySelector('[data-coupon-open]').addEventListener('click', () => openPanel(), options);
    dots.forEach((dot,index) => dot.addEventListener('click', () => navigate(modulo(index - Math.round(phase) + slides.length / 2, slides.length) - slides.length / 2), options));
    root.querySelector('[data-coupon-next]').addEventListener('click', () => navigate(1), options);
    root.querySelector('[data-coupon-previous]').addEventListener('click', () => navigate(-1), options);
    pause.addEventListener('click', () => { manualPaused = !manualPaused; lastTime = performance.now(); render(); }, options);
    dismiss.addEventListener('click', () => {
      if (cycle !== 'closed' && cycle !== 'shaking') {
        manualPaused = false; keyboardIntent = false;
        if (root.contains(document.activeElement)) document.activeElement.blur();
        beginReturn(); render(); return;
      }
      closeCount = Math.min(2, closeCount + 1); save(visit + 'closes',String(closeCount));
      snoozeUntil = closeCount === 1 ? Date.now() + 300000 : 0; save(visit + 'until',String(snoozeUntil));
      dismissed = closeCount >= 2; manualPaused = false; turn = null;
      selectCycle(dismissed ? 'dismissed' : 'snoozed');
      if (root.contains(document.activeElement)) document.activeElement.blur();
      availability(); render();
    }, options);
    root.addEventListener('pointerdown', event => {
      if (event.button !== 0 || held || dismissed || blocked || ['waiting','snoozed'].includes(cycle) || event.target.closest('[data-coupon-dismiss],[data-coupon-open],.gift-dot,.coupon-offers__control')) return;
      const element = event.target.closest('button') || root;
      held = { id: event.pointerId, x: event.clientX, y: event.clientY, phase, began: performance.now(), moved: false, element, mode: mobile.matches && layout === 'dock' ? 'dock' : 'carousel', placement: { ...placement }, cycle };
      keyboardIntent = false;
      element.setPointerCapture(event.pointerId); lastTime = performance.now(); render();
    }, options);
    root.addEventListener('pointermove', event => {
      if (!held || held.id !== event.pointerId) return;
      const distance = event.clientX - held.x;
      if (held.mode === 'dock') {
        const dy = event.clientY - held.y;
        if (!held.moved && Math.hypot(distance,dy) < 7) return;
        held.moved = true; event.preventDefault(); placementMotion = null;
        const view = dimensions();
        placement.left = Math.max(view.left + 14, Math.min(view.left + view.width - 340 * placement.scale - 14, held.placement.left + distance));
        placement.anchor = Math.max(view.top + stageHeight * placement.scale + 22, Math.min(view.top + view.height - 12, held.placement.anchor + dy));
        render(); return;
      }
      if (cycle !== 'showing') return;
      if (!held.moved && Math.abs(distance) < 5) return;
      held.moved = true; event.preventDefault(); turn = null;
      phase = held.phase - distance / Math.max(1,ticket.getBoundingClientRect().width);
      root.dataset.dragDelta = String(distance); paintSlides();
    }, options);
    const release = event => {
      if (!held || held.id !== event.pointerId) return;
      const completed = held; held = null;
      if (completed.moved && completed.mode === 'dock') {
        const view = dimensions();
        const dx = event.clientX - completed.x;
        const side = dx > 12 ? 'right' : dx < -12 ? 'left' : placement.left + 170 * placement.scale > view.left + view.width / 2 ? 'right' : 'left';
        dockPosition = { side, anchor: (placement.anchor - view.top) / view.height };
        save(visit + 'dock',JSON.stringify(dockPosition));
        place('dock'); if (placementMotion) placementMotion.duration = 240;
      } else if (completed.moved) {
        const target = Math.round(phase);
        turn = reduced.matches ? null : { from: phase, to: target, time: 0, duration: 340 };
        if (reduced.matches) phase = target;
        nextTurn = interval; manualPaused = false;
      }
      // A stationary press on the closed box is a tap even when held slowly.
      // Long presses on an open product still must not accidentally follow it.
      if (completed.moved || completed.mode === 'carousel' && completed.cycle === 'showing' && performance.now() - completed.began > 240 || event.type !== 'pointerup') suppressUntil = Date.now() + 500;
      if (completed.element.hasPointerCapture(event.pointerId)) completed.element.releasePointerCapture(event.pointerId);
      lastTime = performance.now(); render();
    };
    root.addEventListener('pointerup', release, options); root.addEventListener('pointercancel', release, options); root.addEventListener('lostpointercapture', release, options);
    root.addEventListener('dragstart', event => event.preventDefault(), options);
    root.addEventListener('keydown', event => { if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); navigate(event.key === 'ArrowRight' ? -1 : 1); } }, options);
    root.addEventListener('focusout', () => { lastTime = performance.now(); }, options);
    document.addEventListener('keydown', () => { keyboardIntent = true; }, { ...options, capture: true });
    document.addEventListener('pointerdown', () => { keyboardIntent = false; }, { ...options, capture: true });
    document.addEventListener('pointermove',event=>{
      if(event.pointerType==='touch'||!placement)return;
      const bounds=root.getBoundingClientRect();
      root.dataset.hovered=String(root.contains(event.target)||(event.clientX>=bounds.left&&event.clientX<=bounds.right&&event.clientY>=bounds.top&&event.clientY<=bounds.bottom));
    }, {...options,passive:true});
    modal.querySelector('[data-coupon-dialog-close]').addEventListener('click', () => modal.close(), options);
    modal.addEventListener('close', () => { lastTime = performance.now(); availability(); }, options);
    modal.addEventListener('click', event => { if (event.target === modal) { const r = modal.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) modal.close(); } }, options);
    modal.querySelectorAll('[data-coupon-subscribe]').forEach(button => button.addEventListener('click', () => { modal.close(); if (welcome) window.dispatchEvent(new CustomEvent('seisso:welcome:open')); else location.assign((window.Shopify?.routes?.root || '/') + '?welcome_offer=1'); }, options));
    const reposition = () => {
      if (placementMotion) placementMotion.to = targetPlacement(layout);
      else placement = targetPlacement(layout);
      render();
    };
    window.addEventListener('resize', reposition, { ...options, passive: true }); window.addEventListener('scroll', reposition, { ...options, passive: true });
    visualViewport?.addEventListener('resize', reposition, { ...options, passive: true }); visualViewport?.addEventListener('scroll', reposition, { ...options, passive: true });
    mobile.addEventListener('change', () => { place(layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured',false); render(); }, options);
    wide.addEventListener('change', reposition, options);
    reduced.addEventListener('change', () => { if (reduced.matches && turn) { phase = turn.to; turn = null; } if (reduced.matches && placementMotion) { placement = placementMotion.to; placementMotion = null; } lastTime = performance.now(); render(); }, options);
    welcome?.addEventListener('close', () => { welcomeClosed = true; availability(); }, options);
    document.addEventListener('visibilitychange', availability, options);
    const observer = new MutationObserver(availability);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open', 'hidden'], childList: true });
    document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root) || event.target.contains(home)) { disposed = true; cancelAnimationFrame(frame); observer.disconnect(); controller.abort(); if (root.hasAttribute('popover') && root.matches(':popover-open')) root.hidePopover(); if (modal.open) modal.close(); } }, options);
    const persist = () => {
      if(designer)return;
      save(visit + 'runtime-v4', JSON.stringify({ version: 4, customer, offers: offerSignature,
        cycle, elapsed, phase, exposure, nextTurn, turn, layout, returnPose,
        manualPaused, burstCount, openCount, dropCount, shakeCount, idleShakeBand }));
    };
    const resetForProductNavigation = () => {
      if (modal.open) modal.close();
      dockPosition = null;
      save(visit + 'dock', '');
      manualPaused = false;
      keyboardIntent = false;
      held = null;
      turn = null;
      particles.length = 0;
      if (context) context.clearRect(0, 0, canvas.width, canvas.height);
      progressLid = 0;
      progressPanel = 0;
      returnPose = { lid: 1, panel: 1 };
      place('dock', false);
      selectCycle('closed');
      availability();
      render();
      persist();
    };
    modal.querySelectorAll('[data-coupon-offer][href]').forEach(offer => offer.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      resetForProductNavigation();
    }, options));
    const restore = value => {
      closeCount = designer ? 0 : Math.min(2, Number(read(visit + 'closes')) || 0);
      snoozeUntil = designer ? 0 : Number(read(visit + 'until')) || 0;
      dismissed = closeCount >= 2;
      held = null; placementMotion = null; keyboardIntent = false;
      if (value) {
        cycle = value.cycle; elapsed = value.elapsed; phase = value.phase;
        exposure = slides.map((_,index) => Math.max(0,Math.min(minimumExposure,Number(value.exposure?.[index]) || 0)));
        nextTurn = Number.isFinite(value.nextTurn) ? value.nextTurn : interval;
        turn = value.turn && ['from','to','time','duration'].every(key => Number.isFinite(value.turn[key])) && value.turn.duration > 0 ? { ...value.turn } : null;
        layout = value.layout === 'dock' ? 'dock' : mobile.matches ? 'center' : 'featured';
        returnPose = value.returnPose || { lid: 1, panel: 1 };
        manualPaused = Boolean(value.manualPaused); burstCount = Number(value.burstCount) || 0;
        openCount = Number(value.openCount) || 0; dropCount = Number(value.dropCount) || 0;
        shakeCount = Number(value.shakeCount) || 0; idleShakeBand = Number(value.idleShakeBand) || 0;
      } else {
        cycle = 'waiting'; elapsed = 0;
        layout = mobile.matches ? 'center' : 'featured';
      }
      if (dismissed) { cycle = 'dismissed'; elapsed = 0; }
      else if (snoozeUntil > Date.now()) { cycle = 'snoozed'; elapsed = 0; layout = 'dock'; }
      else if (cycle === 'snoozed' || cycle === 'dismissed' || !value && closeCount === 1) {
        cycle = 'closed'; elapsed = 0; idleShakeBand = 0; layout = 'dock';
      }
      if (paidSocialQuiet && !dismissed && !(snoozeUntil > Date.now())) {
        cycle = 'closed'; elapsed = 0; idleShakeBand = 0; layout = 'dock';
        progressLid = 0; progressPanel = 0; returnPose = { lid: 1, panel: 1 };
        manualPaused = false; turn = null;
      }
      place(layout,false); render(); availability(); lastTime = performance.now();
      root.dataset.resumed = String(Boolean(value));
    };
    window.addEventListener('pagehide', persist, options);
    window.addEventListener('pageshow', event => {
      if (event.persisted) restore(readRuntime());
      lastTime = performance.now(); availability();
    }, options);
    document.addEventListener('visibilitychange', () => { if (document.hidden) persist(); }, options);
    restore(designer?null:readRuntime());
    root.dataset.ready = 'true';
    // Inactive lazy artwork and offer thumbnails do not block the gift itself.
    artworkReady.catch(() => {}).then(() => { assetsReady = true; lastTime = performance.now(); });
    frame = requestAnimationFrame(tick);
  };
  document.querySelectorAll('[data-coupon-offers]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-coupon-offers]')));
})();


  } catch(e) { console.error(e); }
})();
})();
